module.exports = __webpack_public_path__ + "static/media/GCE_safety-min.d757ed42.jpg";